/*
 * -----------------------------------------------------------------------------
 *  Lucom Interaction Platform
 *  (C) Lucom GmbH, Erkrath. All rights reserved.
 * -----------------------------------------------------------------------------
 */

import type { BaseComponents, Configuration } from "./types";

export const logLevels: Map<string, string> = new Map();

let sharedConfiguration: Configuration = {} as Configuration;

export const configuration = {
    get: (): Configuration => sharedConfiguration,
    set: (configuration: Configuration) => (sharedConfiguration = configuration || ({} as Configuration)),
};

export const baseComponents = {} as BaseComponents;
